export { ProfileModal } from './ProfileModal.component.jsx';
